import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum SquareIconVariant {
  DEFAULT = 'default',
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
export interface ISquareIconProps extends IConDefaultType {
  variant?: SquareIconVariant;
}

export default function SquareIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = SquareIconVariant.DEFAULT,
}: ISquareIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === SquareIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2.5C3.34315 2.5 2 3.84315 2 5.5V19.5C2 21.1569 3.34315 22.5 5 22.5H19C20.6569 22.5 22 21.1569 22 19.5V5.5C22 3.84315 20.6569 2.5 19 2.5H5ZM19 4.5H5C4.44771 4.5 4 4.94772 4 5.5V19.5C4 20.0523 4.44772 20.5 5 20.5H19C19.5523 20.5 20 20.0523 20 19.5V5.5C20 4.94771 19.5523 4.5 19 4.5Z"
            fill={color}
          />
        </svg>
      )}
      {variant === SquareIconVariant.VERTICAL && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 5C3.34315 5 2 6.34315 2 8V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V8C22 6.34315 20.6569 5 19 5H5ZM19 7H5C4.44772 7 4 7.44772 4 8V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V8C20 7.44771 19.5523 7 19 7Z"
            fill={color}
          />
        </svg>
      )}
      {variant === SquareIconVariant.HORIZONTAL && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5 6C19.5 4.34315 18.1569 3 16.5 3L7.5 3C5.84315 3 4.5 4.34315 4.5 6L4.5 20C4.5 21.6569 5.84315 23 7.5 23H16.5C18.1569 23 19.5 21.6569 19.5 20L19.5 6ZM17.5 20L17.5 6C17.5 5.44772 17.0523 5 16.5 5L7.5 5C6.94772 5 6.5 5.44772 6.5 6L6.5 20C6.5 20.5523 6.94772 21 7.5 21H16.5C17.0523 21 17.5 20.5523 17.5 20Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}
